import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
class JhPreOpening extends LitElement {
    constructor() {
        super();
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `<img class="w-100 h-100" src="${paths.preOpeningGif}" />`;
    }
}
customElements.define("jh-pre-opening", JhPreOpening);
//# sourceMappingURL=pre-opening.js.map